<template>
  <div class="flex justify-between items-center color-primary bg-base pa-2 min-h-11">
    <div class="flex-1 font-700">
      <CCheckbox
        v-if="!loading && totalItems > 0"
        v-tooltip="
          areAllSelected
            ? t('canvasUI.components.CBulkToolbar.deselectAll')
            : t('canvasUI.components.CBulkToolbar.selectAll')
        "
        :checked="areAllSelected"
        class="mx-2"
        :disabled="loading"
        :indeterminate="areSomeSelected"
        :label="`${t('canvasUI.contentSelectorApp.contentGridToolbar.all')} (${totalItems})`"
        @click.stop="emit('toggle-select-all')"
      />
    </div>

    <CSectionSelectionActions
      v-if="isDragNDropEnabled"
      :added-item-ids="addedItems.map((item) => item.id)"
      :selected-item-ids="selectedItems.map((item) => item.id)"
      :total-selected="selectedItems?.length || 0"
      @clear-selection="selectedItems = []"
      @items-added="(_, position) => addItems(position)"
      @items-removed="(_) => deleteItems()"
    />
  </div>
</template>

<script setup lang="ts">
import { useI18n } from 'vue-i18n'

import CCheckbox from '@lib/components/CCheckbox/CCheckbox.vue'
import CSectionSelectionActions from '@lib/components/CSectionSelectionActions/CSectionSelectionActions.vue'
import { useStore } from '@content-selector/composables/useStore.ts'

withDefaults(
  defineProps<{
    loading?: boolean
    totalItems: number
    areAllSelected?: boolean
    areSomeSelected?: boolean
  }>(),
  {
    loading: false,
  },
)

const emit = defineEmits(['toggle-select-all'])

const { t } = useI18n()

const { addedItems, selectedItems, addItems, deleteItems, isDragNDropEnabled } = useStore()
</script>
